import {
  type ConversationCartDelivery,
  type ConversationCartItem,
  type ConversationCartVendor,
} from '../value-objects/ConversationTurnItem'

export const toOrderSummaryDeliveryGroups = <
  TVendor extends ConversationCartVendor,
>(
  vendors: TVendor[],
  items: ConversationCartItem[]
): (Omit<TVendor, 'items' | 'deliveries'> & {
  deliveries: ConversationCartDelivery[]
})[] => {
  const pickItems = (lines: ConversationCartItem[]) =>
    items.filter((item) => lines.some((line) => line.id === item.id))

  return vendors
    .map(({ deliveries, items: lines, ...cartVendor }) => ({
      ...cartVendor,
      deliveries: (
        deliveries ?? [{ id: cartVendor.vendor?.id ?? 'items', items: lines }]
      )
        .map((delivery) => ({ ...delivery, items: pickItems(delivery.items) }))
        .filter((delivery) => delivery.items.length > 0),
    }))
    .filter((group) => group.deliveries.length > 0)
}
